import DropMenu from '..';
import Icon, {IconSize} from '../../Icon';
import Button from '../../Button';
import {PowerListOption} from '../../../interface';
import styles from './index.module.scss';
// import assert from 'assert';
import classNames from 'classnames';
import {ArrowDownFillSvg, CheckedSvg} from '../../../icons';

interface PowerListProps {
    className?: string;
    value?: string | number;
    onChange?: (data: any) => void;
    handleBlur?: () => void;
    optionList?: PowerListOption[];
    disabled?: boolean;
    btnName?: string;
    isShowIcon?: boolean;
}
export default (props: PowerListProps) => {
    // (props.optionList || []).map(val => {
    //     val.isChecked = false;
    //     if (val.value === props.value) {
    //         val.isChecked = true;
    //     }
    //     return val;
    // });
    const {optionList = []} = props;
    const checkVal = optionList.find(val => {
        return val.isChecked;
    });
    const {
        className,
        // onPowerListOptionsChange,
        onChange,
        handleBlur,
        disabled = true,
        value = checkVal && checkVal.value,
        btnName = '',
        isShowIcon = true,
    } = props;
    const translateText = optionList.find(val => {
        return val.value === value;
    })?.label;
    const menu = optionList.map(item => {
        return {
            ...item,
            isChecked: value === item.value,
        };
    });
    // eslint-disable-next-line complexity
    const handleClick = (value: string, data?: any) => () => {
        if (!data.disabled) {
            handleBlur && handleBlur();
            onChange && onChange(value);
        }
    };

    const redButton = ['remove'];
    menu.forEach((val: any) => {
        // eslint-disable-next-line no-unused-expressions
        val ? val.label
            = (<div
                className={classNames(styles['dropMenu-listitem-block'], 'dropMenu-listitem-block')}
                onClick={handleClick(val.value, val)}
            >
                <div className={classNames(styles['dropMenu-label-block'], 'dropMenu-label-block')}>
                    <span className={
                        classNames(
                            redButton.includes(val.value) && styles.red,
                            val.disabled && styles.gray,
                            styles['dropMenu-label'],
                            'dropMenu-label',
                            val.isChecked && styles['checked-text'],
                            val.isChecked && 'checked-text',
                            styles['nomal-text'],
                            'nomal-text'
                        )}
                    >
                        {val.label}
                    </span>
                    {
                        isShowIcon && val.isChecked &&
                        <Icon svg={CheckedSvg} style={{color: '#1964fa'}} size={IconSize.XS} />
                    }
                </div>
                <span className="dropMenu-produce">{val.produce}</span>
            </div>) : null;
    });

    // 既不是cmr也不是cme，并且是在当前的邀请协作列表
    // 管理员拥有任何权限
    // 只读成员 没有任何权限
    return (
        <DropMenu
            className={className}
            options={menu}
            value={null}
            triggerType={'click'}
            matchMinWidthToTarget={false}
            disabled={disabled}
            placement={'bottom-end'}
        >
            <div className={classNames(
                disabled && styles.readonly,
                disabled && 'dropMenu-readonly-status',
                'dropMenu-btn'
            )}
            >
                <Button
                    type={'plain'}
                    onClick={handleBlur}
                >
                    {btnName ? btnName : translateText}
                    {
                        <Icon
                            className={
                                classNames(
                                    disabled && styles['dropMenu-visible-icon'],
                                    disabled && 'dropMenu-visible-icon',
                                    styles['dropMenu-showIcon'],
                                    'dropMenu-showIcon'
                                )}
                            svg={ArrowDownFillSvg}
                            size={IconSize.XS}
                        />
                    }
                </Button>
            </div>
        </DropMenu>
    );
};
